import { render, staticRenderFns } from "./SidebarCustomButton.vue?vue&type=template&id=f271ee36&scoped=true&"
import script from "./SidebarCustomButton.vue?vue&type=script&lang=ts&"
export * from "./SidebarCustomButton.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCustomButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SidebarCustomButton.vue?vue&type=style&index=1&id=f271ee36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f271ee36",
  null
  
)

export default component.exports